import { ConfigurationType } from '../dependencies/types';
import {
  BaseElementProperties,
  BaseFieldProperties,
  ApexClassProperties,
  ApexTriggerProperties,
  ApprovalProcessProperties,
  FlowProperties,
  LayoutProperties,
  RecordTypeProperties,
  ValidationRuleProperties,
  WorkflowRuleProperties,
} from '@server/documentation';
import { NameProperties } from '../../parser/ParserTypes';

export enum SearchType {
  apiNameAndLabel = 'NAME_LABEL_SEARCH',
  content = 'CONTENT_SEARCH',
}

export interface SearchListItem {
  id: string;
  name: string;
  label: string;
  fieldType: string;
  type: string;
  parentType: ConfigurationType;
  lastModifiedAtAndBy: string;
  createdAtAndBy: string;
  objectName?: string;
  objectLabel?: string;
  match?: string;
  filename?: string;
  isActive?: boolean;
  metadataId?: string;
}

export type SearchResponse = {
  //should be the same as BE
  [ConfigurationType.apexClasses]: ApexClassProperties[];
  [ConfigurationType.apexTriggers]: ApexTriggerProperties[];
  [ConfigurationType.approvalProcesses]: ApprovalProcessProperties[];
  [ConfigurationType.fields]: BaseFieldProperties[];
  [ConfigurationType.flows]: FlowProperties[];
  [ConfigurationType.objects]: NameProperties[];
  [ConfigurationType.processBuilderFlows]: FlowProperties[];
  [ConfigurationType.validationRules]: ValidationRuleProperties[];
  [ConfigurationType.workflowRules]: WorkflowRuleProperties[];
  [ConfigurationType.layouts]: LayoutProperties[];
  [ConfigurationType.recordTypes]: RecordTypeProperties[];
  [ConfigurationType.others]: BaseElementProperties[];
};

export type MatchData = { filename: string; match: string };

type ConfigurationBaseMatchProperties = BaseElementProperties & MatchData;

export type ContentSearchResponse = {
  [key in keyof SearchResponse]: (SearchResponse[key][number] & MatchData)[];
} & {
  files?: ConfigurationBaseMatchProperties[];
  unclassifiedConfigurations: ConfigurationBaseMatchProperties[];
};
